import styled from "styled-components";
import {hexToRGBA} from "@dropDesk/utils/helpers/colors";

type ButtonType = {
    background: string;
    color: string;
    border: string;
    accent: string;
};

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 10px 0 8px;
`;

export const Button = styled.button<ButtonType>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: ${props => props.background};
  color: ${props => props.color};
  border: 1px solid ${props => props.border};
  border-radius: 999px;
  padding: 8px 18px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  box-shadow: 0 1px 3px ${props => hexToRGBA(props.accent, 0.22)};
  transition: border-color .2s ease, box-shadow .2s ease;

  &:hover {
    border-color: ${props => hexToRGBA(props.color, 0.28)};
    box-shadow: 0 2px 8px ${props => hexToRGBA(props.accent, 0.32)};
  }

  &:disabled {
    pointer-events: none;
    opacity: 0.72;
  }
`;
